import React from "react";
import { CircularProgress } from "@mui/material";

import routes from "./routes";
import useJumboRoutes from "@jumbo/hooks/useJumboRoutes";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import Div from "@jumbo/shared/Div";

const AppRoutes = () => {
  const { isLoading } = useJumboAuth();
  const appRoutes = useJumboRoutes(routes);

  if (isLoading) {
    return (
      <Div
        sx={{
          display: "flex",
          minWidth: 0,
          alignItems: "center",
          alignContent: "center",
          height: "100%",
        }}
      >
        <CircularProgress sx={{ m: "-40px auto 0" }} />
      </Div>
    );
  }

  return <React.Fragment>{appRoutes}</React.Fragment>;
};
export default AppRoutes;
